import { Button, CircularProgress } from "@mui/material";
import React from "react";

const AppButton = ({
  type,
  size,
  valueText,
  minWidth,
  onClick,
  loading,
  height,
}) => {
  return (
    <Button
      type={type}
      variant="contained"
      size={size}
      disabled={loading}
      sx={{
        minWidth: minWidth || "200px",
        height: height || "58px",
        background: "linear-gradient(135deg, #9c27b0 0%, #6a1b9a 100%)",
        color: "white",
        fontWeight: "bold",
        fontSize: "1.1rem",
        padding: "12px 24px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        "&:hover": {
          background: "linear-gradient(135deg, #b533d0 0%, #7e1fa5 100%)",
          transform: "translateY(-2px)",
          boxShadow: "0 8px 16px rgba(156, 39, 176, 0.3)",
        },
        "&:disabled": {
          background: "linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)",
        },
      }}
      onClick={onClick}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: "white" }} />
      ) : (
        valueText
      )}
    </Button>
  );
};

export default AppButton;
